import { KEY_CODE_CTRL } from '%paysera_seat_selection/js/seatSelection/config/constants';
import handleKeyDown from '%paysera_seat_selection/js/seatSelection/redux/component/workflow/reducers/handleKeyDown';
import handleArrowKeys from '%paysera_seat_selection_integration/js/seatings/redux/components/workflow/reducers/handleArrowKeys';

export default (state, { payload }) => {
    const newState = handleKeyDown(state, { payload });
    if (state.modifierKeys.includes(KEY_CODE_CTRL)) {
        return handleArrowKeys(state, { payload });
    }

    return newState;
};
